export const bbxKind = {
  STUDENT_ANSWER: 'student-answer-content',
  MS: 'master-solution-content',
  GS: 'grading-criteria-content',
  TASKS: 'tasks',
};
